import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/ui/button'
import Container from '@/components/container'

import logo from '../../../assets/logo-colour.svg'
import { useMe } from '../../../hooks/API/autenticação/useMe'
import { LocalStorage } from '../../../utilitários/localStorage/LocalStorage'

import { Loader2 } from 'lucide-react'

export const Bloqueado = () => {
  const { errorMe } = useMe()
  const navigate = useNavigate()
  const storage = new LocalStorage()

  function backtologin() {
    storage.remove('@Esforce:Auth-Token')
    navigate('/login')
  }

  return (
    <Container className='flex min-h-svh flex-col items-center justify-center gap-10 bg-esforce-black-200 px-5 py-8'>
      <hgroup className='flex max-w-56 flex-col items-center justify-center gap-5'>
        <img
          alt='logo da esforce na cor verde'
          src={logo}
          className='h-9 w-40'
        />
      </hgroup>
      {errorMe ? (
        <div className='flex w-full flex-col items-center gap-4'>
          <p className='flex flex-col text-center font-archivo text-lg font-normal leading-6'>
            {errorMe?.response?.data.error}
          </p>
          <p className='flex flex-col text-center font-archivo text-lg font-normal leading-6'>
            {`O acesso está temporariamente bloqueado e será liberado ${errorMe?.response?.data.detalhes.proximaLiberacao} `}
          </p>
        </div>
      ) : (
        <Loader2 className='animate-spin' />
      )}
      <Button
        onClick={backtologin}
        size='xl'
        type='button'
        className='mt-7 w-full cursor-pointer bg-esforce-green-200 font-archivo text-sm font-bold text-esforce-black-350 hover:bg-esforce-green-100'
      >
        Voltar para tela de login
      </Button>
    </Container>
  )
}
